import {
	useDispatch,
	useSelector
} from "react-redux";
import {
    useCallback,
    useContext,
    useEffect,
    useState
} from "react";
import {
	notification,
} from "antd";
import {
	Button,
	Loading,
	Modal,
	Icon
} from "~/components";
import {
	UserFormPass,
	UserFormStatus,
	UserFormRole,
	UserSearch,
	UserTable,
	UserFormAdd,
	UserFormEdit
} from "../components";
import {
	apiError,
	handleRequest
} from "~/utils";
import {useCan} from "~/hooks";
import {
	userApi
} from "~/api";

import {AppContext} from "../../../context/AppProvider";
import {
	userActions,
	userErrorSelector,
	userFilterSelector,
	userItemsSelector,
	userLoadingSelector,
	userPaginationSelector
} from "../../../reduxs/User/userSlice";
import ActionBar from "../../../layout/ActionBar";

function User() {

	const can = {
		add: useCan('user_add'),
		edit: useCan('user_edit'),
		password: useCan('user_password'),
		role: useCan('user_roles'),
		status: useCan('user_status'),
		loginAs: useCan('user_login_as'),
	}

	const dispatch = useDispatch();

	const items = useSelector(userItemsSelector);

	const loading = useSelector(userLoadingSelector);

	const error = useSelector(userErrorSelector);

	const pagination = useSelector(userPaginationSelector);

	const filter = useSelector(userFilterSelector);

	const [selectedRowKeys, setSelectedRowKeys] = useState([]);

	const [itemEdit, setItemEdit] = useState({});

	const {rolesData} = useContext(AppContext);

	//Modal show
	const [openModal, setOpenModal] = useState({
		password : false,
		role : false,
	});

	const handleEvent = {

        load: useCallback(() =>
        {
            dispatch(userActions.fetchData(filter));
        }, [dispatch, filter]),

		openModal : (modal) =>
		{
			openModal[modal] = true;
			setOpenModal({...openModal})
		},
		closeModal : (modal) =>
		{
			openModal[modal] = false;
			setOpenModal({...openModal});
		},
		add: async (data) =>
		{
			let [error, response] = await handleRequest(userApi.add(data));

			if (!apiError(`Thêm nhân viên thất bại`, error, response))
			{
				dispatch(userActions.add(response.data));

				handleEvent.closeModal('add');
			}
		},
		edit: async (data) =>
		{

			if (itemEdit?.id === 'undefined')
			{
				notification.error({message: 'Lỗi', description: 'Bạn chưa thành viên'});
				return;
			}

			data.id = itemEdit.id;

			let [error, response] = await handleRequest(userApi.update(data));

			let message = apiError(`Cập nhật thông tin nhân viên thất bại`, error, response);

			if (!message)
			{
				dispatch(userActions.update(response.data));
				handleEvent.closeModal('edit');
			}
		},
		active : async (item) =>
		{

			if (item?.id === 'undefined') {
				notification.error({message: 'Lỗi', description: 'Bạn chưa thành viên'});
				return;
			}
			let [error, response] = await handleRequest(userApi.status({
				id : item.id,
				status : 'public'
			}));

			let message = apiError(`Thay đổi trạng thái thành viên thất bại`, error, response);
			if (!message) {
				dispatch(userActions.update({
					...item,
					status: response.data.status
				}));
			}
		},
		block : async (item) =>
		{
			if (!item?.id)
			{
				notification.error({message: 'Lỗi', description: 'Bạn chưa thành viên'});
				return;
			}

			let [error, response] = await handleRequest(userApi.status({
				id : item.id,
				status : 'block'
			}));

			if (!apiError(`Thay đổi trạng thái thành viên thất bại`, error, response))
			{
				dispatch(userActions.update({
					...item,
					status: response.data.status
				}));
			}
		},
		password: async (data, item) =>
		{
			if (!item?.id)
			{
				notification.error({message: 'Lỗi', description: 'Không có thông tin thành viên để cập nhật'});
				return;
			}

			data.id = item.id;

			let [error, response] = await handleRequest(userApi.password(data));

			let message = apiError(`Cập nhật mật khẩu thất bại`, error, response);

			if (!message)
			{
				notification.success({
					message: 'Thành công', description: `Đổi mật khẩu thành công`
				});
				handleEvent.closeModal('password');
			}
		},
		role: async (data, item) => {

			if (item?.id === 'undefined') {
				notification.error({message: 'Lỗi', description: 'Không có thông tin thành viên để cập nhật'});
				return;
			}

			data.id = item.id;

			let [error, response] = await handleRequest(userApi.role(data));

			let message = apiError(`Cập nhật chức vụ bại`, error, response);

			if (!message) {
				notification.success({
					message: 'Thành công', description: `Đổi chức vụ thành công`
				});
				dispatch(userActions.update({
					...item,
					role: response.data.role,
					roleName: response.data.roleName
				}))
				handleEvent.closeModal('role');
			}
		},
		loginAs: async (item) => {
			localStorage.setItem('access_token_as', item.id);
			window.location.reload(false)
		},
		search: (newFilter) => {
			dispatch(userActions.setFilterWithDebounce(newFilter));
		},
		changePagination: (page) => {
			dispatch(userActions.setFilter({...filter, page }));
		},
		changeSearch: (newFilter) => {
			dispatch(userActions.setFilterWithDebounce(newFilter));
		},
	}

	//Load data
	useEffect(() => {
        handleEvent.load()
	}, [filter]);

	if (error)
	{
		notification.error({message: 'Lỗi', description: error});
	}

	return (
        <>
            <ActionBar title={'Nhân viên'}>
                {can.add && <Button outline leftIcon={Icon.plusCircle} onClick={() => { handleEvent.openModal('add')}}>Thêm mới</Button>}
                <Button outline onClick={handleEvent.load}>{Icon.reload}</Button>
            </ActionBar>
            <div className={'container'}>
                <section>
                    {loading && <Loading noFixed/>}
                    <div className="d-flex justify-content-start gap-1">
                        <UserSearch filter={filter} rolesData={rolesData} onSearchChange={handleEvent.changeSearch}/>
                    </div>
                    {items && <UserTable
                        items={items}
                        handleEvent={handleEvent}
                        setItemEdit={setItemEdit}
                        pagination={pagination}
                        selectedRowKeys={selectedRowKeys}
                        setSelectedRowKeys={setSelectedRowKeys}
                        can={can}
                    />}
                </section>
                {
                    (can.add && openModal.add) &&
                    <Modal title="Thêm nhân viên" visible={openModal.add} onCancel={() => {handleEvent.closeModal('add')}}>
                        <UserFormAdd onHandleSubmit={handleEvent.add} />
                    </Modal>
                }
                {
                    (can.edit && itemEdit?.id && openModal.edit) &&
                    <Modal title="Cập nhật nhân viên" visible={openModal.edit} onCancel={() => {handleEvent.closeModal('edit')}}>
                        <UserFormEdit item={itemEdit} onHandleSubmit={handleEvent.edit} />
                    </Modal>
                }
                {
                    (can.status && itemEdit?.id && openModal.status) &&
                    <Modal title="Thai đổi trạng thái" visible={openModal.status} onCancel={() => {handleEvent.closeModal('status')}}>
                        <UserFormStatus item={itemEdit} onHandleSubmit={handleEvent.status} />
                    </Modal>
                }
                {
                    (can.role && itemEdit?.id && openModal.role) &&
                    <Modal title="Thai đổi chức vụ" visible={openModal.role} onCancel={() => {handleEvent.closeModal('role')}}>
                        <UserFormRole item={itemEdit} onHandleSubmit={handleEvent.role} />
                    </Modal>
                }
                {
                    (can.password && openModal.password && itemEdit?.id) && <Modal title="Đổi mật khẩu" visible={openModal.password} onCancel={() => handleEvent.closeModal('password')}>
                        <UserFormPass item={itemEdit} onHandleSubmit={handleEvent.password} />
                    </Modal>
                }
            </div>
        </>
	)
}
export default User;